import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCarrierList, getFilterPackagesList } from "../../store/actions/incoming";
import _ from "lodash";
import { fetchCompanyFilters, fetchSellerFilters } from "../../store/actions/rateCard";
import { getSelectList } from "../../config/utils";
import SelectMenu from "../common/SelectMenu";
import { getAllSellersList } from "../../store/actions";
import DatePickerComponent from "../common/DatePickerComponent";
import moment from "moment";
import PropTypes from "prop-types";
import Select from "react-select";
import { BillingStatusList } from "../../constant";

const FilterIncoming = (props) => {
  const { filterValue, setFilterValue, handleReset, sellerList, setSellerList, allSellers, setAllSellers } = props;
  const dispatch = useDispatch();
  const [packageTypeList, setPackageTypeList] = useState([]);
  const [sourcesList, setSourcesList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const { filterCompanies, filterSellers } = useSelector((state) => state.RateCardReducer);
  const UserValue = useSelector((state) => state.auth.user);
  const [allCarriers, setAllCarriers] = useState([]);
  const { allCarriersList } = useSelector((state) => state.IncomingReducer);

  const sourcesListData = useSelector(
    (state) => state.IncomingReducer.sourcesList
  );
  const packageTypeListData = useSelector(
    (state) => state.IncomingReducer.PackageTypeList
  );

  useEffect(() => {
    if (!allCarriersList?.length) {
      dispatch(getAllCarrierList());
    };
  }, []);

  useEffect(() => {
    if (allCarriersList?.length) {
      let dataCarriers = allCarriersList?.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.carrierName,
        };
      });
      setAllCarriers(dataCarriers);
    }
  }, [allCarriersList]);

  useEffect(() => {
    let companyList = filterCompanies?.Entity?.listCompanyMasterOrdersEntity || [];
    let sellerList = filterSellers?.Entity?.listSellerMasterOrdersEntity || [];
    if (companyList.length) {
      setCompanyList(getSelectList(filterCompanies?.Entity?.listCompanyMasterOrdersEntity, 'Id', 'name'));
    }
    if (sellerList.length) {
      setAllSellers(getSelectList(sellerList, 'id', 'newSellerName'));
      setSellerList(getSelectList(sellerList, 'id', 'newSellerName'));
    }
  }, [filterCompanies, filterSellers]);

  useEffect(() => {
    let data = {
      pageIndex: 1,
      pageSize: 10,
      sortColumn: 'name',
      sortOrder: 'ascending'
    }; let sellerData = {
      screenType: 2,
      sortColumn: 'sellerName',
      sortOrder: 'ASCENDING'
    };
    dispatch(fetchCompanyFilters(data));
    dispatch(fetchSellerFilters(sellerData));
  }, []);

  useEffect(() => {
    let sourcesListCopyObj = JSON.parse(JSON.stringify(sourcesListData));
    let packageTypeListObj = JSON.parse(JSON.stringify(packageTypeListData));
    setSourcesList(getSelectList(sourcesListCopyObj, 'id', 'source'));
    setPackageTypeList(getSelectList(packageTypeListObj, 'id', 'packageType'));
  }, [sourcesListData, packageTypeListData]);

  const handleApplyFilter = () => {
    let data = { ...filterValue };
    data.pageIndex = 1;
    data.sortColumn = '';
    data.sources = _.map(filterValue.sources, "id");
    data.packageTypes = _.map(filterValue.packageTypes, "id");
    data.sellerIdList = _.map(filterValue.companySellerId, "id");
    data.companyIdList = _.map(filterValue.companyIdList, "Id");
    data.carriers = _.map(filterValue.carriers, "id");
    data.companySellerId = 0;
    data.date = null;
    data.billingStatusList = Array.isArray(filterValue.billingStatusList) ? _.map(filterValue.billingStatusList, item => item?.value || item) : [];
    dispatch(getFilterPackagesList(data));
    setFilterValue({ ...filterValue, pageIndex: 1, sortColumn: '', sellerIdList: filterValue.companySellerId, filterApplied: true });
  };

  const handleChangeFilter = (value, name) => {
    setFilterValue({ ...filterValue, [name]: value });
    if (name === "companyIdList") {
      let companyData = _.map(value, "Id");
      fetchSellers(companyData);
      if (filterValue?.companySellerId?.length) {
        const filteredSellers = filterValue.companySellerId.filter(seller =>
          companyData.includes(parseInt(seller.companyIds)) // NOSONAR
        );
        setFilterValue({ ...filterValue, companySellerId: filteredSellers, companyIdList: value })
      }
    }
  }

  const fetchSellers = async (companyList) => {
    if (companyList.length === 0) {
      setSellerList(allSellers);
      return;
    }
    let data = {
      companyIds: companyList,
    };
    let res = await getAllSellersList(data);
    if (res?.data?.Status === 200) {
      let dataList = res?.data?.Entity?.listSellerMasterOrdersEntity.map(
        (item) => {
          return {
            ...item,
            label: item.sellerAndCompany,
            value: item.id,
          };
        }
      );
      setSellerList(dataList);
    }
  };

  const handleDateChange = (date, fieldName) => {
    let dateSelected = moment(date).utc(true).format();
    setFilterValue({ ...filterValue, [fieldName]: dateSelected });
  };

  return (
    <>
      <div className={filterValue.showFilter ? 'filterContainer show historyFilter' : 'filterContainer historyFilter'}>
        <div className='row mb10 rowBottomSpace fontFix'>
          <div className='col-sm-12 col-lg-4'>
            <label className='labelHead' htmlFor="packageTypes">Package Type</label>
            <SelectMenu
              optionList={packageTypeList}
              handleChange={(value) => handleChangeFilter(value, 'packageTypes')}
              value={filterValue.packageTypes}
              placeholderText={'Select package'}
              id='packageTypes'
              name='packageTypes'
              isMulti={true}
              closeMenuOnSelect={false}
              classPrefix="packageTypes"
            />
          </div>

          <div className="col-sm-12 col-lg-4">
            <label className='labelHead' htmlFor="Source">Source</label>
            <SelectMenu
              optionList={sourcesList}
              handleChange={(value) => handleChangeFilter(value, 'sources')}
              value={filterValue.sources}
              placeholderText={'Select sources'}
              id='Source'
              name='Source'
              isMulti={true}
              closeMenuOnSelect={false}
              classPrefix="source"
            />
          </div>
          <div className="col-sm-12 col-lg-4">
            <label className='labelHead' htmlFor="Carrier">Carrier</label>
            <SelectMenu
              optionList={allCarriers}
              handleChange={(value) => handleChangeFilter(value, 'carriers')}
              value={filterValue.carriers}
              placeholderText={'Select carriers'}
              id='Carrier'
              name='Carrier'
              isMulti={true}
              closeMenuOnSelect={false}
              classPrefix="source"
            />
          </div>
        </div>
        <div className='row rowBottomSpace fontFix'>
          <div className="col-sm-12 col-lg-4">
            <div className='row'>
              <div className='col-12'>
                <label className='labelHead' htmlFor="receivedDates">Received Dates</label>
              </div>

              <div className='col-6 fieldAndLabel mb-2'>
                <span>From:</span>
                <div className='inputHistory'>
                  <DatePickerComponent
                    fieldName={'fromDate'}
                    handleDateChange={handleDateChange}
                    dateField={filterValue.fromDate}
                    maxDate={filterValue.toDate ? new Date(filterValue.toDate) : null}
                  />
                </div>
              </div>

              <div className='col-6 fieldAndLabel mb-2'>
                <span>To:</span>
                <div className='inputHistory'>
                  <DatePickerComponent
                    fieldName={'toDate'}
                    handleDateChange={handleDateChange}
                    dateField={filterValue.toDate}
                    minDate={filterValue.fromDate ? new Date(filterValue.fromDate) : null}
                  />
                </div>
              </div>

            </div>
          </div>
          {UserValue?.Value?.roleName !== 'Seller' && (
            <>
              <div className='col-sm-12 col-lg-4'>
                <label className='labelHead' htmlFor="companyIdList">Company</label>
                <SelectMenu
                  optionList={companyList}
                  handleChange={(value) => handleChangeFilter(value, 'companyIdList')}
                  value={filterValue.companyIdList}
                  placeholderText={'Select company'}
                  id='companyIdList'
                  name='Company'
                  isMulti={true}
                  closeMenuOnSelect={false}
                  classPrefix="company"
                />
              </div>

              <div className='col-sm-12 col-lg-4'>
                <label className='labelHead' htmlFor="companySellerId">Seller</label>
                <SelectMenu
                  optionList={sellerList}
                  handleChange={(value) => handleChangeFilter(value, 'companySellerId')}
                  value={filterValue.companySellerId}
                  placeholderText={'Select sellers'}
                  id='companySellerId'
                  name='companySellerId'
                  isMulti={true}
                  closeMenuOnSelect={false}
                  classPrefix="seller"
                />
              </div>
            </>
          )}
          <div className='col-4'>
            <label className='labelHead' htmlFor="billingStatusList">Billing Status</label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              options={BillingStatusList}
              classNamePrefix="list fontFix"
              id='billingStatusList'
              name="billingStatusList"
              value={filterValue?.billingStatusList || []}
              onChange={(value) =>
                  handleChangeFilter(value, "billingStatusList")
              }
            />
          </div>
          <div className="col-8">
            <div className="filterActionReturn mt-3">
              <button
                className="btn cus-primary-transparent-btn top-btn"
                onClick={handleReset}
              >
                Clear Filter
              </button>
              <button
                className="btn cus-seconday-bg-btn marginLeft5"
                onClick={handleApplyFilter}
              >
                Apply Filter
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

FilterIncoming.propTypes = {
  filterValue: PropTypes.object.isRequired,
  setFilterValue: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  sellerList: PropTypes.array.isRequired,
  setSellerList: PropTypes.func.isRequired,
  allSellers: PropTypes.array.isRequired,
  setAllSellers: PropTypes.func.isRequired
}

export default FilterIncoming;
